import { render, staticRenderFns } from "./SkeletonThumbnail.vue?vue&type=template&id=56cee528&"
import script from "./SkeletonThumbnail.vue?vue&type=script&lang=js&"
export * from "./SkeletonThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports